// Get own resume detail  ***********************
// pathname: /v1/own-resume-detail
// **********************************************************
import { useSwrApi } from '@hooks/useSwrApi';

interface UseSwrOwnResumeDetailProps {
  locale?: Locale;
  serverData?: ApiSchema<'ResumeData'>;
  shouldFetch?: boolean;
}

/**
 * @description SWR Get own resume detail including lead experience and tag cloud.
 * @param props
 */
export const useSwrOwnResumeDetail = (props: UseSwrOwnResumeDetailProps) => {
  const { locale = 'ro', serverData, shouldFetch = true } = props;

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'ResumeData'>>({
    url: '/v1/own-resume-detail',
    locale,
    shouldFetch,
    serverSideData: serverData,
    apiOptions: {
      dedupingInterval: 5 * 60 * 1000, // 5 minutes
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
